<template>
  <div class="page-container">
    <!--工具栏-->
    <el-scrollbar>
      <el-form
        :inline="true"
        :model="filters"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
        :size="size"
      >
        <el-form-item label="礼品名称">
          <el-input
            v-model.trim="filters.giftName"
            placeholder="请输入礼品名称"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否上架">
          <el-select v-model="filters.shelf" clearable placeholder="是否上架">
            <el-option
              v-for="item in whetherOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="el-icon-search"
            label="查询"
            type="primary"
            @click="findPage(null)"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="el-icon-plus"
            label="新增"
            type="warning"
            @click="handleAdd"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="el-icon-refresh"
            label="刷新"
            type="primary"
            @click="handleRefresh"
          />
        </el-form-item>
      </el-form>
    </el-scrollbar>
    <!--表格内容栏-->
    <kt-table
      v-loading="loading"
      :height="'400'"
      element-loading-text="拼命加载中"
      :data="pageResult"
      :columns="filterColumns"
      :operationWidth="280"
      :showEdit="true"
      :showDelete="true"
      :showLook="true"
      @findPage="findPage"
      @handleEdit="handleEdit"
      @handleDelete="handleDelete"
      @handleLook="handleLook"
      @refreshPageRequest="refreshPageRequest"
    >
    </kt-table>
  </div>
</template>

<script>
import KtTable from "@/components/KtTable";
import KtButton from "@/components/KtButton";
export default {
  components: {
    KtTable,
    KtButton,
  },
  data() {
    return {
      loading: true,
      size: "medium",
      filters: {
        giftName: "",
        shelf: "",
      },
      whetherOptions: [],
      columns: [],
      filterColumns: [],
      pageRequest: { pageNum: 1, pageSize: 10 },
      pageResult: {},
      operation: false, // true:新增, false:编辑
      dialogVisible: false, // 新增编辑界面是否显示
      editLoading: false,
    };
  },
  methods: {
    // 刷新
    handleRefresh() {
      this.filters = {}; //清空查询条件
      this.findPage();
    },
    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.findPage();
      }
    },
    // 获取分页数据
    findPage(data) {
      //判断查询条件是否存在
      this.filters.giftName != undefined
        ? (this.pageRequest.giftName = this.filters.giftName)
        : (this.pageRequest.giftName = "");
      this.filters.shelf != undefined
        ? (this.pageRequest.shelf = this.filters.shelf)
        : (this.pageRequest.shelf = "");
      console.log(this.pageRequest);
      this.$postJson("omc/gift/queryListWithPage", this.pageRequest)
        .then((res) => {
          console.log(res.result.list);
          res.result.list.forEach((item) => {
            //处理一下数据,因为后端返回的是 0 和 1 ,在table上显示需将其转化为 否 和 是
            console.log(item.shelf);
            item.shelf == 0 ? (item.shelf = "否") : (item.shelf = "是");
          });
          this.pageResult = res.result; //将值赋给this.pageResult这个对象
          setTimeout(() => {
            this.loading = false;
          }, 500);
        })
        .then(data != null ? data.callback : "");
    },
    // 分页刷新数据
    refreshPageRequest(data) {
      console.log(data);
      this.pageRequest.pageNum = data;
      this.findPage();
    },

    // 删除
    handleDelete(data) {
      console.log(data.params[0].id, data.callback);
      let giftId = data.params[0].id * 1;
      console.log(giftId);
      this.$postForm("omc/gift/deleteById/" + giftId).then((res) => {
        console.log(res);
        var info = res;
        data.callback(info);
      });
    },
    // 显示新增界面
    handleAdd() {
      this.$router.push({ path: "/volunteergiftsCompile" }); //编程式导航跳转
    },
    // 显示编辑界面
    handleEdit(info) {
      console.log(info);
      let dataForm = Object.assign({}, info.row);
      let data = JSON.stringify(dataForm);
      this.$router.push({
        path: "/volunteergiftsCompile",
        query: { res: data },
      }); //编程式导航跳转  params传参
    },
    //查看详情
    handleLook(data) {
      console.log(data);
      let id = data.row.id;
      console.log(id);
      this.$router.push({ path: "/volunteergiftsDetail", query: { id: id } }); //编程式导航跳转  query传参
    },
    // 时间格式化
    dateFormat(row, column, cellValue, index) {
      return format(row[column.property]);
    },
    // 处理表格列过滤显示
    displayFilterColumnsDialog() {
      this.$refs.tableColumnFilterDialog.setDialogVisible(true);
    },
    // 处理表格列过滤显示
    handleFilterColumns(data) {
      this.filterColumns = data.filterColumns;
      this.$refs.tableColumnFilterDialog.setDialogVisible(false);
    },
    // 处理表格列过滤显示
    initColumns() {
      this.columns = [
        { prop: "giftNo", label: "礼品编号", minWidth: 120 },
        { prop: "giftName", label: "礼品名称", minWidth: 120 },
        { prop: "integral", label: "礼品所需积分", minWidth: 130 },
        { prop: "price", label: "礼品价格", minWidth: 120 },
        { prop: "stock", label: "库存", minWidth: 100 },
        { prop: "convertTimes", label: "已兑换", minWidth: 100 },
        { prop: "shelf", label: "是否上架", minWidth: 120 },
      ];
      this.filterColumns = JSON.parse(JSON.stringify(this.columns));
    },
    //初始化是否发货和是否上架
    initialwhethers() {
      var whethers = ["否", "是"];
      for (var i = 0; i < whethers.length; i++) {
        var item = {};
        item.value = i;
        item.label = whethers[i];
        this.whetherOptions.push(item);
      }
    },
  },
  created() {
    this.initialwhethers();
  },
  mounted() {
    this.initColumns();
    this.findPage();
  },
};
</script>

<style lang="scss" scoped>
// ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
//新增 编辑 dialog
@media screen and (max-width: 1599px) {
  ::deep .volunteerdialog .el-dialog {
    width: 60% !important;
  }
}
::deep .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  width: 100.5%;
  height: 100%;
}
::deep .el-form--inline {
  position: relative;
  z-index: 99;
}
.filtersposition {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  bottom: 10px;
  width: 100%;
  height: 56px;
  background: #f2f2f2;
  z-index: 1;
}
</style>